import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { isValidEmail } from 'utils/isValidEmail';
import { useCreateResetSatMutation } from '@satManagement/services/courseAssessmentMenteeService';
import Field from 'components/Field';
import Form from 'components/Form';
import GlobalLoader from 'components/GlobalLoader';
import Input from 'components/Input';
import styles from './CreateResetSatForm.module.scss';

export default function CreateResetSatForm() {
  const [inputEmail, setInputEmail] = useState('');
  const [createResetSat, { error, isSuccess, isLoading: isUpdating }] =
    useCreateResetSatMutation();

  const handleChange = useCallback((event) => {
    setInputEmail(event.target.value);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('SAT reset was successfull for given learner!');
      setInputEmail('');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      if (inputEmail.length !== 0) {
        const email = inputEmail.trim();
        if (isValidEmail(email)) {
          createResetSat({ email });
        } else {
          cogoToast.error('Invalid email format!');
        }
      }
    },
    [createResetSat, inputEmail]
  );

  return (
    <>
      <GlobalLoader isVisible={isUpdating} />
      <Form
        className={styles.pageContainer}
        onSubmit={handleSubmit}
        serverErrors={error?.data?.errors}
      >
        <Field
          name="email"
          label="Learner's email id"
          errorClassName="m-t-xxs"
          serverErrors={error?.data?.errors}
        >
          <Input
            required
            placeholder="Enter email registered with Scaler"
            value={inputEmail}
            onChange={handleChange}
            name="email"
          />
        </Field>
        <Tappable
          type="submit"
          disabled={isUpdating || inputEmail.length < 5}
          component="button"
          className="btn btn-primary btn-long"
        >
          Reset
        </Tappable>
      </Form>
    </>
  );
}
